* {
  box-sizing: border-box;
}

:host {
  display: none;
  max-width: 100%;
  height: 100%;
  background-color: var(--white-layout-302-level-1-elevation);
  flex-direction: column;
  overflow-y: hidden;
}

:host([data-is-visible]) {
  display: block;
}

.header,
.content,
.footer {
  width: 100%;
}

.footer {
  display: flex;
  align-self: flex-end;
  box-shadow: 0px 0px 4px var(--grey-layout-100-12-opacity);
  background-color: var(--white-layout-301-level-0-elevation);
  padding: calc(1.75 * var(--spacer)) calc(5 * var(--spacer));
  z-index: 10;

  &--button {
    margin-right: calc(2 * var(--spacer));

    &#btnCancel {
      margin-left: auto;
      margin-right: 0;
    }
  }
}

.wrapper {
  flex-direction: column;

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .content {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }

  &.is-error {
    .content {
      display: none;
    }
    .loading-error {
      display: block;
    }
  }

  .content {
    min-width: 500px;
    height: 100%;
    overflow-y: scroll;
    padding: 0 calc(4 * var(--spacer)) 50px;
  }
}

#warningPageTitle, #blockPageTitle {
  text-transform: uppercase;
}

.loading-error {
  display: none;
  height: auto;
  width: 500px;
  margin: auto;

  &--message {
    max-width: 310px;
    line-height: 1.25;
  }
}
